import {parseColor,TYPE_MAP} from "../../config";

export default {
  props:{
    data: { type:Array, default:() => ([]) },
    type: { type:Number, default: 3 }
  },
  computed: {
    list: (_this = this) => _this.$props.data?.map((ele,index) => ({
      name: ele?.key,
      color: parseColor(ele.key,index),
      value: TYPE_MAP?.[_this.$props.type]?.formatFn(ele?.value),
      percentage: ele?.percentage ? Number(ele?.percentage * 100).toFixed(2) + '%' : '--%'
    }))
  },
}
